import 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { TireconnectService } from './tireconnect.service';

angular.module('app-lite.tireconnect', [])
.service('tireconnectApi', downgradeInjectable(TireconnectService));
